<template>
  <v-card>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :total-items="total"
      :pagination="pagination"
      :rows-per-page-items="[10, 25, 50]"
      @update:pagination="handlePaginationUpdate"
    >
      <template #items="{ item }">
        <td>
          <v-avatar :size="32">
            <img :src="item.profile_pic" alt="Avatar" />
          </v-avatar>
        </td>
        <td class="text-no-wrap">{{ item.line_name || '-' }}</td>
        <td class="text-no-wrap">{{ item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
        <td class="text-no-wrap">{{ item.beacon_id || '-' }}</td>
        <td class="text-no-wrap">{{ item.beacon_name || '-' }}</td>
        <td class="text-no-wrap">{{ item.beacon_conversation || '-' }}</td>
        <td>
          <div
            class="text-truncate"
            :style="{ maxWidth: '300px', lineHeight: 'inherit !important' }"
          >
            {{ getAnswerText(item.beacon_conversation_answer) || '-' }}
          </div>
        </td>
        <td class="text-no-wrap">{{ item.beacon_conversation_user_tags || '-' }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    pagination: {
      type: Object,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        {
          text: '',
          value: '',
          sortable: false
        },
        {
          text: this.$t('Name'),
          value: 'name',
          sortable: false
        },
        {
          text: `${this.$t('Date')} & ${this.$t('Time')}`,
          value: 'timestamp',
          sortable: false
        },
        {
          text: 'Beacon ID',
          value: 'beaconId',
          sortable: false
        },
        {
          text: this.$t('beacon_name'),
          value: 'name',
          sortable: false
        },
        {
          text: this.$t('beacon_conversation'),
          value: 'conversation',
          sortable: false
        },
        {
          text: this.$t('beacon_message_text'),
          value: 'answer',
          sortable: false
        },
        {
          text: this.$t('Tag'),
          value: 'tags',
          sortable: false
        }
      ]
    }
  },
  methods: {
    getAnswerText(text) {
      try {
        const items = JSON.parse(text)
        const textItem = items.find((item) => item.type === 'text')
        return textItem.text
      } catch (error) {
        return ''
      }
    },
    handlePaginationUpdate(pagination) {
      this.$emit('update:pagination', pagination)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/Customer/DataTable.vue